import Loadable from "app/components/Loadable";
import React, { lazy } from "react";

const ImportSchool = Loadable(lazy(() => import("./ImportSchool.jsx")));
const EditSchool = Loadable(lazy(() => import("./EditSchool.jsx")));

const HolidayRoutes = [
    { path: "/import-schools", element: <ImportSchool/> },
    { path: "/import-schools/edit", element: <EditSchool/> },
];

export default HolidayRoutes;